import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { initializeNativeApp } from '../utils/nativeBridge';

function NativeAppBridge() {
  const navigate = useNavigate();

  useEffect(() => {
    let cleanup = () => {};
    initializeNativeApp(navigate).then((remove) => {
      cleanup = remove || (() => {});
    });
    return () => cleanup();
  }, [navigate]);

  return null;
}

export default NativeAppBridge;